var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoGradient(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1059 27.4773C21.7072 27.5144 21.307 27.4245 20.9625 27.2202C20.7108 26.9618 20.5902 26.6031 20.6346 26.2452C20.6439 25.9472 20.6794 25.6506 20.7409 25.3588C20.8004 25.0241 20.8773 24.6928 20.9713 24.3661L22.0173 20.7674C22.1251 20.4122 22.1964 20.0469 22.23 19.6772C22.23 19.2783 22.2832 19.0035 22.2832 18.844C22.3054 18.1331 22.0019 17.4509 21.4588 16.9915C20.7909 16.4787 19.9591 16.2267 19.1188 16.2824C18.5167 16.2915 17.9192 16.3901 17.3461 16.5749C16.7197 16.7699 16.0608 17.0033 15.3695 17.2752L15.0682 18.4452C15.272 18.3743 15.5202 18.2945 15.8038 18.2058C16.0744 18.1257 16.3549 18.0839 16.637 18.0818C17.0328 18.0389 17.4312 18.1361 17.7627 18.3565C17.9878 18.6252 18.0935 18.9742 18.0552 19.3227C18.0542 19.6207 18.0215 19.9179 17.9577 20.209C17.8956 20.5193 17.8158 20.8472 17.7183 21.1928L16.6636 24.8092C16.5786 25.1453 16.5106 25.4855 16.4598 25.8285C16.4183 26.1222 16.3976 26.4183 16.3977 26.7148C16.3933 27.4306 16.7206 28.1081 17.284 28.5496C17.9622 29.0704 18.8059 29.3285 19.6594 29.2764C20.2604 29.2888 20.8594 29.2019 21.4322 29.0193C21.9345 28.848 22.6051 28.6028 23.4443 28.2837L23.7279 27.1669C23.5006 27.2612 23.2665 27.3382 23.0277 27.3973C22.7256 27.4663 22.4154 27.4931 22.1059 27.4773Z",
    fill: "url(#info_gradient_fill)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2138 10.4148C22.7314 9.97174 22.0959 9.73339 21.4411 9.75C20.7867 9.73522 20.1517 9.97334 19.6683 10.4148C18.7823 11.1788 18.6834 12.5164 19.4474 13.4025C19.5155 13.4815 19.5893 13.5553 19.6683 13.6234C20.6778 14.5263 22.2044 14.5263 23.2138 13.6234C24.0998 12.8519 24.1926 11.5082 23.4211 10.6222C23.357 10.5484 23.2876 10.479 23.2138 10.4148Z",
    fill: "#119ED9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0C8.73044 0 0 8.73044 0 19.5C0 30.2696 8.73044 39 19.5 39C30.2696 39 39 30.2696 39 19.5C39 8.73044 30.2696 0 19.5 0ZM19.5 37.2273C9.70948 37.2273 1.77275 29.2905 1.77275 19.5C1.77275 9.70948 9.70948 1.77275 19.5 1.77275C29.2905 1.77275 37.2273 9.70948 37.2273 19.5C37.2273 29.2905 29.2905 37.2273 19.5 37.2273Z",
    fill: "url(#info_gradient_ring)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_gradient_fill",
    x1: 15.0156,
    y1: 16.8414,
    x2: 25.8446,
    y2: 19.2806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_gradient_ring",
    x1: -0.236951,
    y1: 1.69862,
    x2: 45.7432,
    y2: 17.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGradient);
export default __webpack_public_path__ + "static/media/info_gradient.c9c8bc88699c5a37b01e2c6fbcf1a7ab.svg";
export { ForwardRef as ReactComponent };